import { ProductDetailThemeSizeConfig } from './types';

const large: ProductDetailThemeSizeConfig = {
  productDetail: {},
};

export default large;
